import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'cipo-state',
  imports: [CommonModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './state.component.scss',
  template: `
    <p
      [class]="stateClass()"
      [title]="name() | translate"
      [ngStyle]="{
        backgroundColor: bgColor(),
        color: textColor(),
        fontWeight: fontWeight(),
        fontStyle: fontStyle(),
        textDecoration: textDecoration(),
        fontSize: fontSize(),
      }"
    >
      {{ name() | translate }}
    </p>
  `,
})
export class CipoStateComponent {
  size = input<'normal' | 'big'>('normal');
  customClass = input<string>('');
  name = input.required<string>();
  bgColor = input.required<string>();
  textColor = input<string>();
  fontWeight = input<string>();
  fontStyle = input<string>();
  textDecoration = input<string>();
  fontSize = input<string>();

  stateClass = computed(() => `cipo--state${this.size() === 'big' ? '--big ' : ''} ${this.customClass()}`);
}
